module.exports = __webpack_public_path__ + "img/A9.569b515c.svg";